/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://o4xsidozyzcbfiyjjxb6e76jjm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-u6bwziljfnfs3lh43m2t6qb45e",
    "aws_cognito_identity_pool_id": "us-east-1:11a4b169-d1e4-4c1c-8364-0b286de7fdec",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_q3QyMbyLL",
    "aws_user_pools_web_client_id": "6rfhbd6m8qo48av71393eik9ii",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
